import { render, staticRenderFns } from "./StatisticsSatisfactionBlock.vue?vue&type=template&id=4a0daeb1"
import script from "./StatisticsSatisfactionBlock.vue?vue&type=script&lang=js"
export * from "./StatisticsSatisfactionBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports